import './XaviorPulseLoader.css'

interface XaviorPulseLoaderProps {
  /**
   * Label rendered above the pulsing logo. The default is the neutral
   * "Loading…" copy used for transient session/route loaders. Use a more
   * specific label (e.g. "Preparing your workspace…") only when the
   * underlying operation actually corresponds to that wording — see #2410,
   * #2516, #2568 for why "Loading your workspace…" must not be the default.
   */
  label?: string
  className?: string
}

export function XaviorPulseLoader({
  label = 'Loading…',
  className = '',
}: XaviorPulseLoaderProps) {
  return (
    <div className={`xavior-pulse-loader ${className}`}>
      <span className="xavior-pulse-loader__label">{label}</span>
      <div className="xavior-pulse-loader__logo-wrap">
        <div className="xavior-pulse-loader__glow" />
        <img src="/favicon.svg" alt="Xavior" className="xavior-pulse-loader__logo" />
      </div>
    </div>
  )
}
